import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  savePost,
  unsavePost,
  reportPostInFirebase,
} from "../../../pages/auth/utils/firebase/userOperations";
import {
  togglePostLike as toggleLike,
  isPostLiked,
} from "../../../firebase/likesApi";
import { addToSavedPosts, removeFromSavedPosts } from "../postSlice";

export const togglePostLike = createAsyncThunk(
  "posts/toggleLike",
  async ({ postId, userId }, { rejectWithValue }) => {
    try {
      const result = await toggleLike(postId, userId);
      return { postId, ...result };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const checkPostLike = createAsyncThunk(
  "posts/checkPostLike",
  async ({ postId, userId }, { rejectWithValue }) => {
    const checkStartedAt = Date.now();
    try {
      const liked = await isPostLiked(postId, userId);
      return { postId, isLiked: liked, checkStartedAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const savePostToLocal = createAsyncThunk(
  "posts/savePost",
  async (post, { dispatch, rejectWithValue }) => {
    try {
      // Optimistic add
      dispatch(addToSavedPosts(post));
      await savePost(post);
      return post;
    } catch (error) {
      // Revert optimistic add on failure
      dispatch(removeFromSavedPosts({ postId: post.id }));
      return rejectWithValue(error.message);
    }
  },
);

export const unsavePostFromLocal = createAsyncThunk(
  "posts/unsavePost",
  async (postId, { getState, dispatch, rejectWithValue }) => {
    // Optimistically remove and keep a copy to allow revert
    const original = getState().posts.savedPosts.find((p) => p.id === postId);
    dispatch(removeFromSavedPosts({ postId }));
    try {
      await unsavePost(postId);
      return postId;
    } catch (error) {
      if (original) {
        dispatch(addToSavedPosts(original));
      }
      return rejectWithValue(error.message);
    }
  },
);

export const reportPost = createAsyncThunk(
  "posts/reportPost",
  async (payload, { rejectWithValue }) => {
    try {
      await reportPostInFirebase(payload);
      return { postId: payload?.postId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
